import { isPresent } from '@ember/utils';
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  primaryKey: 'token',
  keyForRelationship(key) {
    switch (key) {
      case 'subunit':
        return 'unit_token';
      default:
        throw new Error(`Unrecognized relationship key: ${key}`);
    }
  },
  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    const newPayload = payload.devices;
    return this._super(store, primaryModelClass, newPayload, id, requestType);
  },
  normalizeSingleResponse(store, primaryModelClass, payload, id, requestType) {
    const newPayload = payload.device;
    return this._super(store, primaryModelClass, newPayload, id, requestType);
  },
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);
    if (isPresent(json.device_profile)) {
      const deviceProfile = {
        settings: json.device_profile.settings,
        token: json.device_profile.token,
        version: json.device_profile.version
      };
      json.device_profile = deviceProfile;
    } else {
      json.device_profile = null;
    }
    return {
      device: json
    };
  }
});